import type { DashboardDataset } from './types';

export const initialDashboardDatasetState: DashboardDataset = {
  project: null,
  site: null,
  userHasManageSitePermission: false,
};
